import { Outlet } from '@tanstack/react-router'
import { AppHeader } from '@/widgets/app-header'
import { BookingModal } from '@/widgets/booking-modal'
import s from './AppShell.module.css'

/**
 * Лейаут лежит в слое `app`, а не в `widgets`, намеренно: он импортирует `widgets/app-header`,
 * а `widgets → widgets` — это межслайсовый импорт внутри слоя, FSD его запрещает и Steiger
 * завалит сборку. `app → widgets` — легальный импорт вниз.
 *
 * `BookingModal` смонтирована здесь, а не в роуте: карточку брони открывают с пяти экранов
 * (шахматка, список, задачи, сводка, чаты) глобальным search-параметром `?booking=`, и
 * отдельный роут размонтировал бы экран под ней. Слой перекрывает и шапку приложения
 * (z-index 51 против 40/39 у шапки) — так и задумано, у карточки своя шапка.
 * Пока `?booking=` в адресе нет, Radix не монтирует из неё ничего.
 */
export function AppShell() {
  return (
    <div className={s.root}>
      <AppHeader />
      {/*
       * `data-scroll-restoration-id` — чтобы восстановление прокрутки пережило переезд со скролла
       * документа внутрь элемента. Роутер отслеживает любой прокручиваемый элемент, но без этого
       * атрибута опознаёт его структурным селектором (`div:nth-child(2) > …`), то есть ключ ломался
       * бы от любой перестановки разметки. С атрибутом ключ стабилен.
       */}
      <div className={s.content} data-scroll-restoration-id="app-content">
        <Outlet />
      </div>
      <BookingModal />
    </div>
  )
}
